import React, { useContext } from "react";
import { Amplitude } from 'react-amplitude-hooks';
import { Link } from 'react-router-dom';
import { AuthContext } from 'States/auth/authState';
import { ROUTES } from "Router/Routes";
import custom_cart_icon from "Assets/images/custom_cart_icon.png"

const CustomCartButton = ({ itemsCount, md }) => {
  const { isActive } = useContext(AuthContext);

  return (
    <Amplitude>
      {({ logEvent }) => (
        <Link
          to={isActive ? ROUTES.cart : ""}
          className="flex"
          onClick={() => (isActive ? logEvent("Cart opened") : null)}
        >
          <div className="relative z-40 rounded-md flex justify-center items-center">
            <img
              data-qa="cart-icon"
              style={{ height: md ? '19px' : "30px" }}
              src={custom_cart_icon}
              alt="shopping cart"
            />
            <div
              className="absolute flex justify-center items-center px-4 rounded-full text-xxs color-white"
              style={{
                top: "-8px",
                right: "-8px",
                color: "#201f1f",
                backgroundColor: "#e1e2e5"
              }}
            >
              {itemsCount}
            </div>
          </div>
        </Link>
      )}
    </Amplitude>
  );
};

export default CustomCartButton;
